import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <div>This is a intern task for Spark Foundation Organization</div>
      <div>Submitted By:- Aditya Saha, Final Year NIT Agartala</div>
      <div>
        <a
          href="https://github.com/adityasaha39/TSF-Banking-System"
          target="_blank"
          rel="noreferrer"
        >
          Github Repository
        </a>
      </div>
    </div>
  );
};

export default Footer;
